module.exports = __webpack_public_path__ + "img/icon-arrow-down.2201f9ba.svg";